module.exports = __webpack_public_path__ + "images/thumbs-up-fill4eadcb13ef54f994f1c141b5cf82950c.svg";